import { render, staticRenderFns } from "./cModalDetalleCaja.vue?vue&type=template&id=6f2e69a3"
import script from "./cModalDetalleCaja.vue?vue&type=script&lang=js"
export * from "./cModalDetalleCaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports